<template>
  <div id="add-user">
    <v-btn block class="button-add-user" @click="dialog = true">
      <v-icon left>mdi-plus-circle-outline</v-icon>
      เพิ่มผู้ใช้งาน
    </v-btn>
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-title class="tw-mt-4">
          <div class="tw-font-bold tw-text-xl">เพิ่มผู้ใช้งานใหม่</div>
        </v-card-title>
        <v-card-text class="tw-pb-0">
          <v-row>
            <v-col>
              <v-text-field v-model="email" label="กรุณากรอกอีเมล" single-line outlined
                            class="input-style" :disabled="registerAndSendEmailLoading"></v-text-field>
<!--              <v-text-field v-model="email" label="กรุณากรอกอีเมล" @input="search" single-line outlined-->
<!--                            class="input-style" :disabled="registerAndSendEmailLoading"></v-text-field>-->
            </v-col>
          </v-row>
<!--          <div v-if="userSearch">-->
<!--            <p>{{ userSearch.nameFirstTH }} {{ userSearch.nameLastTH }}</p>-->
<!--          </div>-->
          <v-radio-group v-model="role" row :disabled="registerAndSendEmailLoading" class="tw-mt-0">
            <v-radio v-if="userAuth?.isEngineer"  label="SLD Admin" color="#6ec39b" value="developer"></v-radio>
            <v-radio :label="product?.isPdfDoc ? 'IT Admin' : 'Owner'" color="#6ec39b" value="owner"></v-radio>
            <v-radio label="User" color="#6ec39b" value="user"></v-radio>
          </v-radio-group>
        </v-card-text>
        <save-alert :status="emailStatus && (emailStatus === 'success' ? 'success': 'error')"
                    :error-text="alertText[emailStatus]"
                    success-text="ส่งอีเมลลงทะเบียนสำเร็จ" v-if="emailStatus"></save-alert>
        <v-card-actions class="tw-mb-2">
          <v-spacer></v-spacer>
<!--          <v-btn color="#6ec39b" text @click="addUser" v-if="userSearch" :disabled="registerAndSendEmailLoading">-->
<!--            <v-icon left>mdi-plus-circle-outline</v-icon>-->
<!--            เพิ่มผู้ใช้งาน-->
<!--          </v-btn>-->
<!--          <v-btn color="#6ec39b" text @click="sendEmailInvite" v-else-if="email && !userSearch" :disabled="registerAndSendEmailLoading">-->
          <v-btn color="#6ec39b" text @click="sendEmailInvite" :disabled="registerAndSendEmailLoading" class="tw-tracking-normal tw-text-lg tw-mr-2">
            <v-progress-circular
              indeterminate
              color="green"
              style="margin-right: 10px;"
              v-if="registerAndSendEmailLoading"
            ></v-progress-circular>
            <img
              src="/images/icons/icon_send_email.svg"
              class="tw-mr-2 tw-w-6"
              v-else
            />
            ส่งอีเมล
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapState} from "vuex";
import firebase from "firebase/app";
import "firebase/auth"
import fc from "@/firebaseConfig";
import SaveAlert from '../save-alert'

const axios = require("axios");

export default {
  name: 'AddUser',
  components:{
    SaveAlert
  },
  props:{
    product: Object,
  },
  data() {
    return {
      email: null,
      dialog: false,
      role: 'owner',
      registerAndSendEmailLoading: false,
      emailStatus: null,
      alertText:{
        error: "เพิ่มผู้ใช้ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
        sendError: "ไม่สามารถส่งอีเมลได้ กรุณาตรวจสอบอีเมลและลองใหม่อีกครั้ง",
      }
    }
  },
  computed: mapState({
    userSearch: state => state.user.userSearch,
    userAuth: state => state.user.userData,
  }),
  methods: {
    // search: function () {
    //   if (this.email) {
    //     this.$store.dispatch('user/search', {email: this.email})
    //   }
    // },
    // addUser: function () {
    //   this.dialog = false
    //   let companyId = this.$route.params.companyId
    //   this.$store.dispatch('user/addUserInCompany', {companyId: companyId, user: this.userSearch, role: this.role}).then(() => {
    //     this.email = ""
    //     this.$store.dispatch('user/setSearchEmpty')
    //   })
    // },
    sendEmailInvite: async function () {
      this.registerAndSendEmailLoading = true
      // get user token
      let token = await firebase.auth().currentUser.getIdToken(/* forceRefresh */ false)
        .then(function (idToken) {
          return idToken
        });
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': 'JWT ' + token
      }

      let data = {
        companyID: this.$route.params.companyId,
        email: this.email,
        role: this.role
      }

      await axios.post(fc.cloudFunctionUrl + "registerUserAndSendEmail", data, {headers})
        .then((response) => {
          if (response.status === 200) {
            this.emailStatus = 'success'
            this.email = ""
          }
        }, (error) => {
          this.emailStatus = error.response.data === 'Mail Server Error' ? 'sendError' : 'error'
        });
      this.registerAndSendEmailLoading = false
    }
  },
  watch:{
    dialog:{
      handler: function (){
        if(!this.dialog){
          this.emailStatus = null
          this.email = null
          this.role = 'owner'        }
      }
    }
  }
}
</script>

<style lang="scss">
#add-user {
  .v-application .headline {
    font-family: "Noto Sans Thai", "Noto Sans", sans-serif !important;
  }

  .input-style.v-input .v-input__slot {
    border-radius: 10px;
  }

  .v-text-field__details {
    display: none !important;
  }

  .button-add-user {
    background-color: white !important;
    border-top: thin solid #6ec39b;
    border-bottom: thin solid #6ec39b;
    box-shadow: unset !important;
    border-radius: unset;
  }

  .alert-detail {
    padding-left: 20px;
    padding-right: 20px;
  }
}
</style>
